import { AbstractSource } from "../../../../base/infrastructure/drawing";
import { IContentSource } from "../../../../base/domain/drawing";

export class EditableFormatReferenceFileSource extends AbstractSource {
  constructor(getToken: () => string, public formatId: number, public fileId: number) {
    super(getToken);
  }

  protected getSource(): string {
    const url = "/api/format-editor/format/" + this.formatId + "/reference/" + this.fileId  + "?token=" + this.token;
    console.debug("[Source] " + url);
    return url;
  }

  public clone(): IContentSource {
    return new EditableFormatReferenceFileSource(
      this._getToken,
      this.formatId,
      this.fileId,
    );
  }
}
